import type { Profession } from 'src/shared/features/users/schemas/profession'

import type { ReferralDataField } from './referral'

// Shared field groups
const CORE_CLIENT_INFO: ReferralDataField[] = [
  'clientType',
  'clientFirstName',
  'clientLastName',
  'clientEmail',
  'clientPhone',
]

const PROPERTY_INFO: ReferralDataField[] = [
  'propertyStreetAddress1',
  'propertyStreetAddress2',
  'propertyCity',
  'propertyState',
  'propertyZip',
  'desiredLocations',
  'propertyType',
]

export const referralInfoByProfession: Record<Profession, ReferralDataField[]> = {
  real_estate_agent: [
    ...CORE_CLIENT_INFO,
    ...PROPERTY_INFO,
    'timeframe',
    // Buy specific
    'priceRange',
    // Lease specific
    'budget',
    'bedrooms',
    'bathrooms',
  ],

  mortgage_loan_officer: [
    ...CORE_CLIENT_INFO,
    ...PROPERTY_INFO,
    'loanType',
    'exactPrice',
    'priceRange',
    'loanPurpose',
    // Purchase specific
    'downPaymentEstimate',
    'incomeEstimate',
    'assetsEstimate',
    'employmentStatus',
    'creditScoreEstimate',
    'isPreApproved',
    // Refinance Specific
    'refinanceReason',
    'estimatedPropertyValue',
    'mortgageBalance',
  ],

  real_estate_insurance_broker: [
    ...CORE_CLIENT_INFO,
    ...PROPERTY_INFO,
    'timeframe',
    'dwellingCoverage',
    'liabilityCoverage',
    'personalPropertyCoverage',
    'deductibleAmount',
    'additionalEndorsements',
    'carrierName',
    'coverageLevelDetails',
    'pastClaims',
  ],

  real_estate_attorney: [
    ...CORE_CLIENT_INFO,
    ...PROPERTY_INFO,
    'attorneyTransactionType',
    'contractStatus',
    'timeframe',
  ],

  contractor: [
    ...CORE_CLIENT_INFO,
    ...PROPERTY_INFO,
    'projectType',
    'budget',
    'squareFootageEstimate',
    'descriptionOfWork',
    'materialPreferences',
    'desiredStartDate',
    'desiredEndDate',
  ],

  property_inspector: [
    ...CORE_CLIENT_INFO,
    ...PROPERTY_INFO,
    'budget',
    'yearBuilt',
    'squareFootageEstimate',
    'timeframe',
    'knownPropertyIssues',
    'additionalTestNeeded',
  ],

  real_estate_appraiser: [
    ...CORE_CLIENT_INFO,
    ...PROPERTY_INFO,
    'appraiserTransactionType',
    'bedrooms',
    'bathrooms',
    'squareFootageEstimate',
    'lotSize',
    'uniqueFeatures',
    'estimatedPropertyValue',
    'approvedLoanAmount',
    'downPaymentEstimate',
  ],

  title_company_rep: [
    ...CORE_CLIENT_INFO,
    ...PROPERTY_INFO,
    'titleTransactionType',
    'desiredClosingDate',
    'dateFlexibility',
    'additionalServices',
    'approvedLoanAmount',
    'downPaymentEstimate',
  ],
}
